import * as React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { formatCurrencyValue, parseCurrencyValue, validateCurrencyValue } from '../../../util/PaymentUtils';

interface CurrencyInputProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  /** The amount in cents (integer). E.g., 1200 = $12.00 */
  value?: number;
  /** Callback with the parsed integer value (cents), not an event object. */
  onChange?: (value: number) => void;
}

/**
 * A reusable currency input component that formats values as USD.
 */
const CurrencyInput: React.FC<CurrencyInputProps> = ({ value, onChange, ...textFieldProps }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (validateCurrencyValue(inputValue)) {
      if (onChange) {
        onChange(parseCurrencyValue(inputValue));
      }
    }
  };

  return (
    <TextField
      {...textFieldProps}
      value={formatCurrencyValue(value ?? 0, true)}
      onChange={handleChange}
    />
  );
};

export default CurrencyInput;
